import {EnvironmentProviders, makeEnvironmentProviders} from '@angular/core';
import {DialogService} from 'primeng/dynamicdialog';
import {DynamicDialogService} from '../service/dialog.service';

export function provideDynamicDialog(): EnvironmentProviders {
  return makeEnvironmentProviders([
    DialogService,
    DynamicDialogService,
  ]);
}

export {DynamicDialogService} from '../service/dialog.service';
export {DIALOG_DATA, DIALOG_REF, DialogRef} from '../model/dialog.model';

export type {
  DynamicDialogConfig,
  DialogPosition,
  DialogHeaderTemplate,
  DialogFooterTemplate,
  DialogTemplateCtx,
} from '../model/dialog.model';
